// extracted by mini-css-extract-plugin
export default {"modal":"jL4W1V","description":"i_HoPL","button":"Yk4dMq"};